export enum ResourceIdType {
    STEUERBARE_RESOURCE_ID,
    TECHNISCHE_RESOURCE_ID,
    STEUERGRUPPE_ID
}
